import { render, staticRenderFns } from "./CampaignMatches.vue?vue&type=template&id=4af2eb20&scoped=true&"
import script from "./CampaignMatches.vue?vue&type=script&lang=js&"
export * from "./CampaignMatches.vue?vue&type=script&lang=js&"
import style0 from "./CampaignMatches.vue?vue&type=style&index=0&id=4af2eb20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af2eb20",
  null
  
)

export default component.exports